<template>
  <div>
     <v-card outlined>
       <v-card-text>
          <v-row no-gutters>
            <v-col md="4">
              <v-row>
                <v-col>
                  <v-text-field
                    v-model="filter.search"
                    placeholder="Название"
                    dense
                  />
                </v-col>
                <v-col>
                  <v-btn @click="modals.new = true">Создать api-ключ</v-btn>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <Table
            :headers="headers"
            :items="apiKeys"
            :loading="loading"
            :items-per-page="apiKeysPerPage"
            :server-items-length="totalApiKeys"
            :page="page"
            :sort-by="sort.field"
            :sort-desc="sort.desc"
            @update:request="updateRequest"
            @update:sort-by="updateSortField"
            @update:sort-desc="updateSortDesc"
            item-key="id"
            class="elevation-1"
          >
            <template v-slot:item.id="{ item }">
              {{ item.id }}
            </template>
            <template v-slot:item.name="{ item }">
              {{ item.name }}
            </template>
            <template v-slot:item.last_request="{ item }">
              {{ item.last_request | dateTime }}
            </template>
            <template v-slot:item.created_at="{ item }">
              {{ item.created_at | dateTime }}
            </template>
            <template v-slot:item.options="{ item }">
              <v-btn icon x-small>
                <v-icon @click="editApiKeyModalOpen(item)">edit</v-icon>
              </v-btn>
              <v-btn icon x-small>
                <v-icon @click="deleteApiKeyModalOpen(item)">delete</v-icon>
              </v-btn>
            </template>
          </Table>
       </v-card-text>
     </v-card>
    <NewApiKeyModal
      :show.sync="modals.new"
      @apiKey:save="createNewApiKey($event)"
    />
    <EditApiKeyModal
      :show.sync="modals.edit"
      :api-key="selectedApiKey"
      @apiKey:save="editApiKey($event)"
    />
    <v-overlay v-model="overlay" absolute>
      <h1>Ключ доступа к API: {{ token }}</h1>
      <p>
        <v-btn
          color="success"
          @click="overlay = false; token = ''"
        >
          Закрыть
        </v-btn>
      </p>
    </v-overlay>
    <ConfirmModal
      v-if="selectedApiKey"
      title="Внимание"
      :dialog.sync="modals.confirm.value"
      :confirmBtnText="'Удалить API-ключ'"
      contentClass="esh-theme adminModal"
      @confirm="deleteApiKey(selectedApiKey)"
    >
      <template #body>
        <v-col>
          Вы точно хотете удалить API-ключ {{ selectedApiKey.name }}?
        </v-col>
      </template>
    </ConfirmModal>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import { BASE } from '@/config'
import { Table, ConfirmModal } from '@/components/common'
import NewApiKeyModal from "@/views/superadmin/external/NewApiKeyModal";
import EditApiKeyModal from "@/views/superadmin/external/EditApiKeyModal";
import {
  GET_API_KEYS,
  CREATE_NEW_API_KEY,
  UPDATE_API_KEY,
  DELETE_API_KEY
} from '@/requests/superadmin'

export default {
  name: 'ApiKeysSuperAdmin',
  components: {
    EditApiKeyModal,
    NewApiKeyModal,
    ConfirmModal,
    Table
  },
  data() {
    return {
      headers: [
        { text: 'id', value: 'id', sortable: true },
        { text: 'Название', value: 'name', sortable: true },
        { text: 'Последний запрос', value: 'last_request', sortable: true },
        { text: 'Создано', value: 'created_at', sortable: true },
        { text: '', value: 'options', sortable: false },
      ],
      apiKeys: [],
      page: 1,
      totalApiKeys: 0,
      apiKeysPerPage: BASE.LIMIT,
      loading: false,
      selectedApiKey: null,
      overlay: false,
      token: null,
      filter: {
        search: '',
      },
      sort: {
        field: undefined,
        desc: undefined
      },
      modals: {
        edit: false,
        new: false,
        confirm: {
          value: false,
        }
      }
    }
  },
  mounted() {
    this.getData()
  },
  watch: {
    'filter.search': function(state, prevState) {
      if (state.length > prevState.length && state.length >= BASE.SEARCH_MIN_LETTERS) {
        this.searchApiKeys()
      } else if (state.length < prevState.length && prevState.length >= BASE.SEARCH_MIN_LETTERS) {
        this.searchApiKeys()
      }
    }
  },
  methods: {
    searchApiKeys: debounce(function() {
      this.getDataFromFirstPage()
    }, 300),
    updateRequest({ page, itemsPerPage, offset }) {
      this.apiKeysPerPage = itemsPerPage
      this.page = page
      this.getData({ offset })
    },
    editApiKeyModalOpen(item) {
      this.selectedApiKey = item
      this.modals.edit = true
    },
    deleteApiKeyModalOpen(item) {
      this.selectedApiKey = item
      this.modals.confirm.value = true
    },
    getDataFromFirstPage() {
      this.page = 1
      this.getData()
    },
    updateSortDesc(desc) {
      this.sort.desc = Array.isArray(desc) ? desc[0] : desc
      this.getDataFromFirstPage()
    },
    updateSortField(field) {
      this.sort.field = Array.isArray(field) ? field[0] : field
    },
    async getData(params = {}) {
      try {
        this.loading = true
        const { data: { results, count } } = await GET_API_KEYS({
          limit: this.apiKeysPerPage,
          name: this.filter.search.length >= BASE.SEARCH_MIN_LETTERS ? this.filter.search : '',
          ordering: this.sort.field ? `${this.sort.desc ? '-' : ''}${this.sort.field}` : null,
          ...params
        })

        this.totalApiKeys = count
        this.apiKeys = results
      } catch (error) {
        this.$notify({
          type: 'error',
          text: 'Не удалось загрузить информацию о API-ключах'
        })
      } finally {
        this.loading = false
      }
    },
    async createNewApiKey(apiKey) {
      try {
        const { data } = await CREATE_NEW_API_KEY(apiKey)
        this.getData()
        this.overlay = true
        this.token = data.api_key
      } catch (error) {
        this.$notify({
          type: 'error',
          text: 'Не удалось создать новый API-ключ'
        })
      }
    },
    async editApiKey(apiKey) {
      try {
        const { data } = await UPDATE_API_KEY(apiKey.id, apiKey)
        this.apiKeys = this.apiKeys.map(apiKey => apiKey.id === data.id ? data : apiKey)
      } catch (error) {
        this.$notify({
          type: 'error',
          text: 'Не удалось обновить API-ключ'
        })
      }
    },
    async deleteApiKey(apiKey) {
      try {
        await DELETE_API_KEY(apiKey.id)
        this.$notify({
          type: 'success',
          text: `API-ключ ${apiKey.name} успешно удален`
        })
        this.getData()
      } catch (error) {
        this.$notify({
          type: 'error',
          text: 'Не удалось удалить API-ключ'
        })
      }
    }
  }
}
</script>